import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({}).set('Login', new Immutable.Map({}))

/* Types */
export const ACTION_LOGIN_COGNITO = 'ACTION_LOGIN_COGNITO'

export const ACTION_LOGIN_OAUTH = 'ACTION_LOGIN_OAUTH'

/* Reducer */
export default (state = initialState, action) => {

	let object = action.Obj

	switch (action.type) {
		case ACTION_LOGIN_OAUTH:

			object.type = 'ejecutivo'
			sessionStorage.uid = object.profile.samaccountname
			sessionStorage.mail = object.profile.mail
			sessionStorage.lastname = object.profile.lastname
			sessionStorage.firstname = object.profile.firstname
			sessionStorage.access_token = object.access.access_token
			sessionStorage.refresh_token = object.access.refresh_token
			sessionStorage.bpm_token = object.access.bpm_token
			sessionStorage.type = 'Ejecutivo'
			localStorage.type= 'Ejecutivo'

			return state.set('Login', new Immutable.Map(object))

		case ACTION_LOGIN_COGNITO:

			object.type = 'donataria'
			sessionStorage.access_token = object.access_token
			sessionStorage.refresh_token = object.refresh_token
			sessionStorage.bpm_token = object.bpm_token
			sessionStorage.mail = object.mail
			sessionStorage.uid = object.mail
			sessionStorage.type = 'Donataria'
			localStorage.type= 'Donataria'

			return state.set('Login', new Immutable.Map(object))
		default:
			return state;
	}
};

/* Action Creators */

export const loginOAuth = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'auth/oauth/login',
			method: "POST",
			data: Object.assign({
				"username": form.username,
				"password": form.password
			})
		}).request().then(response => {
			dispatch({ type: ACTION_LOGIN_OAUTH, Obj: response.data})
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false))
			throw error
		})
	}
}

export const loginCognito = (form) => {
	localStorage.idDonataria = ''

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'auth/cognito/login',
			method: "POST",
			data: Object.assign({
				"username": form.username,
				"password": form.password
			})
		}).request().then(response => {
			response.data.mail = form.username
			dispatch({ type: ACTION_LOGIN_COGNITO, Obj: response.data})
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false))
			throw error
		})
	}
}

export const logoutOAuth = (token) => {

	return (dispatch) => {
		dispatch(isLoading(true));
		return new ClientHttpRequest({
			service: 'auth/oauth/logout',
			method: "POST",
			data: Object.assign({
				"token": token
			})
		}).request().then(() => {
			dispatch(isLoading(false));
		}).catch(error => {
			dispatch(isLoading(false));
			throw error;
		})
	}
}


// WEBPACK FOOTER //
// ./src/modules/Login/index.js